import React, { useEffect, useState } from 'react';
import SwiperCore, { A11y, Autoplay, EffectFade, Pagination } from 'swiper';
import './_featuredConcerts.scss';
import ArrowBtn from '../../common/arrow_btn';

import PropTypes from 'prop-types';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/effect-fade/effect-fade.scss';
import { Link } from 'react-router-dom';
import { useDate as getCurrentDate } from '../../../hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { timeConvert as tConvert } from '../../../utils/tools';
// install Swiper components
SwiperCore.use([Pagination, A11y, EffectFade, Autoplay]);

export default function FeaturedConcerts ({ data }) {
  const [cardID, setCardID] = useState(10);
  const [sectionVisible, setSectionVisible] = useState(false);


  function openCard (id) {
    setCardID(id);
  }

  useEffect(() => {
    if (data?.length) {
      setSectionVisible(true)
      openCard(data[0].id);
    }
  }, [data]);

  return (
      sectionVisible
          ?
          <section className='upcoming_concerts'>
            <div className='upcoming_concerts_block'>
              <div className='upcoming_concerts_head'>
                <div className='title'>
                  <div className='doted-border'>
                    <img
                        src='/media/icons/inclassica/calendar.svg'
                        alt='calendar icon'
                    />
                  </div>
                  <p>UPCOMING CONCERTS</p>
                </div>
                <div className='upcoming_concerts_link'>
                  <ArrowBtn link='/calendar' title='GO TO CALENDAR' />
                </div>
              </div>

              <div className='concert_card_list mt-3'>
                {data &&
                data.map((el, i) => {
                  return (
                      <div
                          key={i}
                          className={`concert_card ${cardID === el.id ? 'active' : ''}`}
                          onMouseEnter={() => openCard(el.id)}
                      >
                        <Link to={`/calendar/${el.slug}`} rel='noopener noreferrer'>
                          <div className='concert_card_wrapper'>
                            <div className='initial-view'>
                              <div className='card_date'>
                                {el.to_be_confirmed ? (
                                    <h3>
                                      <p className='month'>TBC</p>
                                    </h3>
                                ) : (
                                    <>
                                      <h3>
                                        <p className='day'>
                                          {getCurrentDate(el.date).day}
                                        </p>{' '}
                                        <p className='month'>
                                          {getCurrentDate(el.date).month}
                                        </p>
                                      </h3>
                                      <div className='card_date_info'>
                                        <span>START</span>
                                        <p>{tConvert(el.time)}</p>
                                      </div>
                                    </>
                                )}
                              </div>
                              <div className='concert_card_info'>
                                <h4 dangerouslySetInnerHTML={{ __html: el.title }} />

                                {el.artists && el.artists.length && (
                                    <ul className='concert_orchestra'>
                                      {el.artists.map(
                                          (itm, indx) =>
                                              itm.role === 'orchestra' && (
                                                  <li
                                                      key={indx}
                                                      className='concert_orchestra_items'
                                                  >
                                                    <span>{itm.name}</span>
                                                    <span>{itm.country}</span>
                                                  </li>
                                              )
                                      )}
                                    </ul>
                                )}

                                <ul className='concert_artists'>
                                  {el.artists.map(
                                      (item, i) =>
                                          item.role === 'conductor' && (
                                              <li key={i}>
                                                <span>CONDUCTOR:</span>
                                                <div className='concert_artists_data'>
                                                  <img
                                                      src={item.avatar}
                                                      alt={`${item.name} ${item.surname}`}
                                                  />
                                                  <span
                                                      className='concert_artists_name'
                                                      dangerouslySetInnerHTML={{
                                                        __html: `${item.name} ${item.surname}`,
                                                      }}
                                                  />
                                                </div>
                                              </li>
                                          )
                                  )}
                                </ul>
                                <ul className='concert_artists concert_artists_soloists'>
                                  {el.artists &&
                                  el.artists.length &&
                                  el.artists.map(
                                      (itm, indx) =>
                                          itm.role === 'soloist' && (
                                              <li
                                                  key={indx}
                                                  className='concertFeaturedSoloist'
                                              >
                                                <span>SOLOISTS:</span>
                                                <div className='concert_artists_data'>
                                                  <img
                                                      src={itm.avatar}
                                                      alt={`${itm.name} ${itm.surname}`}
                                                  />
                                                  <span
                                                      className='concert_artists_name'
                                                      dangerouslySetInnerHTML={{
                                                        __html: `${itm.name} ${itm.surname}`,
                                                      }}
                                                  />
                                                </div>
                                                {/* <ReactTooltip
                                                                 id={`artists_tooltip_${indx}`}
                                                                 className="custom-tooltip"
                                                                 delayHide={0}
                                                                 effect="solid"
                                                                 place="bottom"
                                                                 type="light"
                                                                 /> */}
                                              </li>
                                          )
                                  )}
                                </ul>

                                <div className='concert_link'>
                                  <ArrowBtn url={el.ticket_url} title='BUY TICKET' />
                                </div>
                              </div>
                            </div>

                            <div className='second-view'>
                              <div className='card_date'>
                                {el.to_be_confired ? (
                                    <h3>
                                      <p className='month'>TBC</p>
                                    </h3>
                                ) : (
                                    <>
                                      <h3>
                                        <p className='day'>
                                          {getCurrentDate(el.date).day}
                                        </p>{' '}
                                        <p className='month'>
                                          {getCurrentDate(el.date).month}
                                        </p>
                                      </h3>
                                      <div className='card_date_info'>
                                        <span>START</span>
                                        <p>{tConvert(el.time)}</p>
                                      </div>
                                    </>
                                )}
                              </div>
                              <div className='concert_card_info'>
                                <h4 dangerouslySetInnerHTML={{ __html: el.title }} />
                                <ul
                                    className='concert_artists'
                                    style={{
                                      width: `${
                                          cardID !== el.id
                                              ? (el.artists.filter(
                                              (e) => e.role === 'soloist'
                                              ).length +
                                              1) *
                                              3 -
                                              el.artists.filter(
                                                  (e) => e.role === 'soloist'
                                              ).length
                                              : (el.artists.filter(
                                              (e) => e.role === 'soloist'
                                              ).length +
                                              1) *
                                              3
                                      }vw`,
                                    }}
                                >
                                  {el.artists.find(
                                      (item) => item.role === 'conductor'
                                  ) && (
                                      <li>
                                        <span>CONDUCTOR</span>
                                        <img
                                            src={
                                              el.artists.find(
                                                  (item) => item.role === 'conductor'
                                              )?.avatar
                                            }
                                            alt='CONDUCTOR'
                                        />
                                      </li>
                                  )}
                                  {el.artists.map(
                                      (itm, indx) =>
                                          itm.role === 'soloist' && (
                                              <li
                                                  key={indx}
                                                  style={{
                                                    marginLeft: `${
                                                        cardID !== el.id ? '-1vw' : '0'
                                                    }`,
                                                  }}
                                                  className='concertFeaturedSoloist'
                                              >
                                                <span>SOLOISTS</span>
                                                <img src={itm.avatar} alt='SOLOISTS' />
                                              </li>
                                          )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                  );
                })}
              </div>

              <div className='concert_card_list mt-3 concert_card_list_mobile'>
                <Swiper
                    speed={1000}
                    // autoplay={{disableOnInteraction: false, delay: 6000}}
                    spaceBetween={20}
                    freeMode
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    // onSwiper={(swiper) => console.log(swiper)}
                    // onSlideChange={() => console.log('slide change')}
                >
                  {data &&
                  data.map((el, i) => {
                    return (
                        <SwiperSlide key={i}>
                          <div key={i} className='concert_card'>
                            <Link
                                to={`/calendar/${el.slug}`}
                                rel='noopener noreferrer'
                            >
                              <div className='concert_card_wrapper'>
                                <div className='initial-view'>
                                  <div className='card_date'>
                                    {el.to_be_confirmed ? (
                                        <h3>
                                          <p className='month'>TBC</p>
                                        </h3>
                                    ) : (
                                        <>
                                          <h3>
                                            <p className='day'>
                                              {getCurrentDate(el.date).day}
                                            </p>{' '}
                                            <p className='month'>
                                              {getCurrentDate(el.date).month}
                                            </p>
                                          </h3>
                                          <div className='card_date_info'>
                                            <span>START</span>
                                            <p>{tConvert(el.time)}</p>
                                            <span>END</span>
                                            <p>{el.end_date}</p>
                                          </div>
                                        </>
                                    )}
                                  </div>
                                  <div className='concert_card_info'>
                                    <h4
                                        dangerouslySetInnerHTML={{ __html: el.title }}
                                    />
                                    <ul className='concert_orchestra'>
                                      {el.artists &&
                                      el.artists.length &&
                                      el.artists.map(
                                          (itm, indx) =>
                                              itm.role === 'orchestra' && (
                                                  <li
                                                      key={indx}
                                                      className='concert_orchestra_items'
                                                  >
                                                    <span>{itm.name}</span>
                                                    <span>{itm.country}</span>
                                                  </li>
                                              )
                                      )}
                                    </ul>
                                    <div className='card_footer'>
                                      <ul className='concert_artists'>
                                        {el.artists.map(
                                            (item, i) =>
                                                item.role === 'conductor' && (
                                                    <li
                                                        key={i}
                                                        style={{ transitionDelay: '0.5s' }}
                                                    >
                                                      <span>CONDUCTOR</span>
                                                      <img
                                                          src={item.avatar}
                                                          alt={`${item.name} ${item.surname}`}
                                                      />
                                                    </li>
                                                )
                                        )}
                                      </ul>
                                      <ul className='concert_artists concert_artists_soloists'>
                                        {el.artists.map(
                                            (itm, indx) =>
                                                itm.role === 'soloist' && (
                                                    <li
                                                        key={indx}
                                                        style={{
                                                          transitionDelay: `${
                                                              0.5 + (indx + 1) / 10
                                                          }s`,
                                                        }}
                                                        className='concertFeaturedSoloist'
                                                    >
                                                      <span>SOLOISTS</span>
                                                      <img
                                                          src={itm.avatar}
                                                          alt={`${itm.name} ${itm.surname}`}
                                                      />
                                                    </li>
                                                )
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='concert_card_mobileLink'>
                                <ArrowBtn url={el.ticket_url} title='BUY TICKET' />
                              </div>
                            </Link>
                          </div>
                        </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>

              <div className='concert_card_list mt-3 concert_card_list_tablet'>
                <Swiper
                    speed={1000}
                    // autoplay={{disableOnInteraction: false, delay: 6000}}
                    spaceBetween='-40%'
                    freeMode
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    // onSwiper={(swiper) => console.log(swiper)}
                    // onSlideChange={() => console.log('slide change')}
                >
                  {data &&
                  data.map((el, i) => {
                    return (
                        <SwiperSlide key={i}>
                          <div key={i} className='concert_card'>
                            <Link
                                to={`/calendar/${el.slug}`}
                                rel='noopener noreferrer'
                            >
                              <div className='concert_card_wrapper'>
                                <div className='initial-view'>
                                  <div className='card_date'>
                                    {el.to_be_confirmed ? (
                                        <h3>
                                          <p className='month'>TBC</p>
                                        </h3>
                                    ) : (
                                        <>
                                          <h3>
                                            <p className='day'>
                                              {getCurrentDate(el.date).day}
                                            </p>{' '}
                                            <p className='month'>
                                              {getCurrentDate(el.date).month}
                                            </p>
                                          </h3>
                                          <div className='card_date_info'>
                                            <span>START</span>
                                            <p>{tConvert(el.time)}</p>
                                            <span>END</span>
                                            <p>{el.end_date}</p>
                                          </div>
                                        </>
                                    )}
                                  </div>
                                  <div className='concert_card_info'>
                                    <h4
                                        dangerouslySetInnerHTML={{ __html: el.title }}
                                    />
                                    <ul className='concert_orchestra'>
                                      {el.artists &&
                                      el.artists.length &&
                                      el.artists.map(
                                          (itm, indx) =>
                                              itm.role === 'orchestra' && (
                                                  <li
                                                      key={indx}
                                                      className='concert_orchestra_items'
                                                  >
                                                    <span>{itm.name}</span>
                                                    <span>{itm.country}</span>
                                                  </li>
                                              )
                                      )}
                                    </ul>
                                    <div className='card_footer'>
                                      <ul className='concert_artists'>
                                        {el.artists.map(
                                            (itm, i) =>
                                                itm.role === 'conductor' && (
                                                    <li
                                                        key={i}
                                                        style={{ transitionDelay: '0.5s' }}
                                                    >
                                                      <span>CONDUCTOR</span>
                                                      <img
                                                          src={itm.avatar}
                                                          alt={`${itm.name} ${itm.surname}`}
                                                      />
                                                    </li>
                                                )
                                        )}
                                      </ul>

                                      <ul className='concert_artists concert_artists_soloists'>
                                        {el.artists.map(
                                            (itm, indx) =>
                                                itm.role === 'soloist' && (
                                                    <li
                                                        key={indx}
                                                        style={{
                                                          transitionDelay: `${
                                                              0.5 + (indx + 1) / 10
                                                          }s`,
                                                        }}
                                                        className='concertFeaturedSoloist'
                                                    >
                                                      <span>SOLOISTS</span>
                                                      <img
                                                          src={itm.avatar}
                                                          alt={`${itm.name} ${itm.surname}`}
                                                      />
                                                    </li>
                                                )
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='concert_card_mobileLink'>
                                <ArrowBtn url={el.ticket_url} title='BUY TICKET' />
                              </div>
                            </Link>
                          </div>
                        </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </section>
          :
          <div style={{height: '10vh'}}/>
  );
}

FeaturedConcerts.propTypes = {
  data: PropTypes.array,
};
